import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-grid">
          <div className="hero-image-left">
            <img src="/home_banner_left.png" alt="Students" className="hero-img-left" />
          </div>
          <div className="hero-text">
            <h1 className="hero-title">
              Clarity, Direction, &<br /><span className="highlight">Informed Decisions</span><br />after Class 12
            </h1>
            <p className="hero-subtitle">
              An Integrated Career & College Intelligence Platform for Students, Parents, and Institutions
            </p>
            <div className="hero-cta-group">
              <a href="https://12thplus.com/app/login" className="btn btn-primary">Get Started Free</a>
              <Link to="/partner" className="btn btn-outline">Partner with us</Link>
            </div>
          </div>
          <div className="hero-image-right">
            <img src="/home_banner_right.png" alt="Career guidance" className="hero-img-right" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
